import { useState } from 'react';
import { HeaderOption, SearchProps } from '@types/HeaderContextType.types';
import HeaderContext from '@hooks/HeaderContext';
import { Box, Fab } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import Header from '@Layout/Header';

const HeaderProvider: React.FC = ({ children, openNav }) => {
    const [title, setTitle] = useState<string>('');
    const [fabAction, setFabAction] = useState<React.ReactNode>(null);
    const [options, setOptions] = useState<HeaderOption[]>([]);
    const [quickActions, setQuickActions] = useState<HeaderOption[]>([]);
    const [searchProps, setSearchProps] = useState<SearchProps | undefined>();
    const [titleSuffix, setTitleSuffix] = useState<string>('');

    const contextData = {
        title,
        fabAction,
        options,
        quickActions,
        searchProps,
        titleSuffix,
        setTitle,
        setFabAction,
        setOptions,
        setQuickActions,
        setSearchProps,
        setTitleSuffix,
    };

    return (
        <HeaderContext.Provider value={contextData}>
            <Header
                openNav={openNav}
                title={title}
                titleSuffix={titleSuffix}
                quickActions={quickActions}
                searchProps={searchProps}
            />
            {/* <Box
                sx={{
                    flex: 1,
                    overflow: 'auto',
                }}
            > */}
            {children}
            {/* </Box> */}
            {fabAction && (
                <Fab
                    onClick={fabAction}
                    color="primary"
                    sx={{
                        position: 'fixed',
                        bottom: 40,
                        right: 64,
                    }}
                >
                    <AddRounded />
                </Fab>
            )}
        </HeaderContext.Provider>
    );
};

export default HeaderProvider;
